import { render } from "./MyHomes.vue?vue&type=template&id=8cb1edac&scoped=true"
import script from "./MyHomes.vue?vue&type=script&lang=js"
export * from "./MyHomes.vue?vue&type=script&lang=js"

import "./MyHomes.vue?vue&type=style&index=0&id=8cb1edac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb1edac"]])

export default __exports__